export default __webpack_public_path__ + "static/media/proj.e529c77f.jpg";